export default function(exception) {
    console.error(exception)
}